type Params = string[] | string;

export const textWithParams = (content:string, params?:Params) => {
    if(params) {
        const result = content.replace(/\{(\d+)\}/g, function(match, number) {

            if(typeof params === 'string') {
                return number === '0' ? params : match;
            }

            return params[number] || match;
        });

        return result;
    }

    return content;

};
